import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import { ModalProps } from "../../../helpers/constants";
import Modal from "../../../components/common/form/Modal";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { useGetDeliveryModalDocumentsQuery, useLazyViewDeliverDocumentsQuery, useLazyViewFileQuery, } from "../orderFilesApi";
import { formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import MultiFreeFormField from "../../../components/common/form/MultiFreeFormField";
import { skipToken } from "@reduxjs/toolkit/query";
import { useDeliverPdfMutation, useGetContactEmailByOrderIdQuery, useGetOrderByOrderIdAndTypeQuery, useLazyGetContactEmailQuery } from "../ordersApi";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { createOptionTypeListFromArray, loadPdf } from "../../../helpers/utils/Utils";
import { useGetBranchByIdQuery } from "../../customer/branchApi";
import ButtonTray from "../../../components/common/form/ButtonTray";

interface Props extends ModalProps {
    productId: any;
    orderId: any;
    orderQuery: any;
}

const DocumentDeliverModal: FC<Props> = ({ show, setShow, orderId, productId, orderQuery }) => {

    const [selectedDocIds, setSelectedDocIds] = useState<any[]>([]);
    const [deliveryEmails, setDeliveryEmails] = useState<string[]>([]);
    const [fileId, setFileId] = useState<string | null>(null);
    const [deliveryFiles, { isLoading }] = useDeliverPdfMutation();
    const [viewFile, { isFetching }] = useLazyViewDeliverDocumentsQuery();
    const [downloadFileStart, setDownloadFileStart] = useState<boolean>(false);
    const [contactEmailsDataApi, contactEmailsData] = useLazyGetContactEmailQuery();
    const [date, setDate] = useState("");
    const orderData = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: "OTHER" });
    const { data: documentData } = useGetDeliveryModalDocumentsQuery({
        orderFileType: ["TaxCertificate", "HOAFull", "HOAContact", "CADPrintout", "SOA", "NTP", "NOO", "INVOICE", "Other"],
        orderId,
        "sortOrder": "desc",
    });

    useEffect(() => {
        if (orderData.data) {
            contactEmailsDataApi(orderData.data);
        }
    }, [orderData.data]);

    useEffect(() => {
        if (contactEmailsData?.data && contactEmailsData?.data.length > 0) {
            setDeliveryEmails(contactEmailsData?.data ?? []);
        }
    }, [contactEmailsData]);

    const { data: branchData } = useGetBranchByIdQuery(
        orderQuery?.data?.branchId ? {
            branchId: orderQuery?.data?.branchId,
        } : skipToken);



    useEffect(() => {
        if (documentData?.data?.length > 0) {
            setFileId(documentData?.data[0].id);
        }
    }, [documentData]);


    useEffect(() => {
        if (fileId) {
            viewFile({ fileId, isDownload: false, isOpenInFrame: true });
        }
    }, [fileId]);


    const handleDeliveryEmailsChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: any }) => {
        const { value } = "target" in e ? e.target : e;
        setDeliveryEmails(value);
    };


    const columns: DataTableColumn[] = [
        {
            label: "",
            accessor: "id", canSort: false,
            cell: (props: any) => {
                return <>
                    <input
                        type="checkbox"
                        id={props.row.original.id}
                        checked={selectedDocIds.some((e: any) => e.id === props.row.original.id)}
                        onChange={(e: any) => {
                            const isAlreadySelected = selectedDocIds.some((e: any) => e.id === props.row.original.id);
                            let updatedSelectedDocs;

                            if (isAlreadySelected) {
                                updatedSelectedDocs = selectedDocIds.filter((e: any) => e.id !== props.row.original.id);
                            } else {
                                updatedSelectedDocs = [...selectedDocIds, props.row.original];
                            }

                            setSelectedDocIds(updatedSelectedDocs); // <-- properly update state
                            setDate(props.row.original.id + Date.now());
                        }}
                        onClick={(e) => {
                            loadPdf(props.row.original.id);

                            setDate(props.row.original.id + Date.now());
                        }}
                    />

                </>
            }
        },
        {
            label: "Name",
            accessor: "filename",
            canSort: false,
        },
        {
            label: "Type",
            accessor: "fileType",
        },
        {
            label: "Delivered",
            accessor: "dateDelivered",
            cell: (props: any) => formatValueAsDateAndTime(props.row.original.dateDelivered),
        },
    ];

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        await handleRTKQuery(async () => {
            await deliveryFiles({
                orderId: orderId,
                deliveryEmail: deliveryEmails,
                docList: selectedDocIds,
                productId
            }).unwrap();
        },
            () => {
                setShow(false);
                setDeliveryEmails([]);
            }
        );

    };


    return (
        <Modal
            title="Delivery Documents"
            show={show}
            setShow={setShow}
            className="w-3/4"
            fields={
                // <Form onSubmit={handleSubmit} fields={
                <>
                    <p className="ml-1 text-surface-0">Select the documents you would like to deliver</p>
                    <div className="md:grid sm:block grid-cols-12 gap-3">
                        <div className="col-span-5">
                            <DataTable
                                columns={columns}
                                defaultFilter={{
                                    orderFileType: ["TaxCertificate", "HOAFull", "HOAContact", "CADPrintout", "SOA", "NTP", "NOO", "INVOICE", "Other"],
                                    orderId,
                                    "sortOrder": "desc",
                                }}
                                actions={{
                                    fetchAction: useGetDeliveryModalDocumentsQuery,
                                }}
                                renderOptions={{
                                    skipUserSettingRender: true,
                                }}
                                appendFilterToUrl={false}

                            />
                        </div>
                        <div className="col-span-7">
                            <iframe
                                src={""}
                                style={{ width: "100%", minHeight: "500px", overflow: "visible" }}
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </div>


                    <div className="border-t border-surface-5 flex justify-between" >
                        {branchData && branchData.emailNotificationMode !== "OFF" && (
                            
                            <MultiFreeFormField
                                defaultOptions={createOptionTypeListFromArray(deliveryEmails)}
                                placeholder="abc@org.com..."
                                onChange={handleDeliveryEmailsChange}
                                name="deliveryEmails"
                                label="Notification"
                                required={true}
                            />
                        )}



                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "close",
                                    },
                                    buttonType: "button"
                                },
                                {
                                    buttonProps: {
                                        btnText: "Deliver",
                                        type: "submit",
                                        onClick: handleSubmit,
                                        isLoading: isLoading || (downloadFileStart && isFetching),
                                        isDisabled: branchData?.emailNotificationMode === "OFF" ? selectedDocIds.length === 0 : (selectedDocIds.length === 0 || deliveryEmails.length === 0)
                                    },
                                    buttonType: "button",

                                }
                            ]}
                            align="end"
                            gap={2}
                        />

                    </div>
                </>

            }
        />
    );
};

export default DocumentDeliverModal;
